export default __webpack_public_path__ + "assets/images/e4434c531c1294b0e0a20f4180276207.svg";